import React from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

type FrontendAddonHeaderProps = {
  addonName?: string;
  addonPath?: string;
  listPath: string;
  parentTitle: string;
};

export const FrontendAddonHeader: React.FC<FrontendAddonHeaderProps> = ({
  addonName,
  addonPath,
  listPath,
  parentTitle,
}) => {
  return (
    <div className={styles.headerTitle}>
      <Link to={listPath} className={styles.parentLink}>
        {parentTitle}
      </Link>
      {addonName && (
        <>
          <span className={styles.separator}>/</span>
          {addonPath ? (
            <Link
              to={addonPath}
              className={`${styles.parentLink} ${styles.parentLinkShrink}`}
            >
              {addonName}
            </Link>
          ) : (
            <span className={styles.addonName}>{addonName}</span>
          )}
        </>
      )}
    </div>
  );
};
